<div
    #modal
    class="sgt-cliente-analise-mercado-revisao-aprovar-modal modal fade">
    <div class="modal-dialog modal-xl modal-dialog-scrollable modal-success">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>
                <h6 class="modal-subtitle" *ngIf="subtitle">
                    {{subtitle}}
                </h6>
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <!-- Loading Revisão -->
                    <ng-template [ngIf]="isLoadingRevisao">
                        <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando Revisão
                    </ng-template>

                    <ng-template [ngIf]="!isLoadingRevisao && revisao">
                        <!-- Revisão -->
                        <sgt-cliente-analise-mercado-revisao-form-info
                            [revisao]="revisao">
                        </sgt-cliente-analise-mercado-revisao-form-info>

                        <!-- Aprovação -->
                        <ng-template [ngIf]="req">
                            <div class="row">
                                <div class="form-group col-12">
                                    <label for="revisaoAprovarJustificativa" class="col-form-label">Justificativa</label>
                                    <textarea class="form-control" [(ngModel)]="req.justificativa" name="revisaoAprovarJustificativa" id="revisaoAprovarJustificativa"
                                        #revisaoAprovarJustificativa="ngModel" #textAreaJustificativa rows="5" sgtAutosize placeholder="Informe a justificativa da aprovação" required="required" minlength="15">
                                    </textarea>
                                    <p class="form-text text-muted">
                                        Informe uma justificativa do por que você está aprovando esta revisão
                                    </p>
                                    <sgt-form-control-error
                                        *ngIf="revisaoAprovarJustificativa.errors && revisaoAprovarJustificativa.errors.required && revisaoAprovarJustificativa.dirty"
                                        msgError="A justificativa é obrigatório">
                                    </sgt-form-control-error>
                                    <sgt-form-control-error
                                        *ngIf="revisaoAprovarJustificativa.errors && revisaoAprovarJustificativa.errors.minlength"
                                        msgError="A justificativa deve ter no mínimo 15 caracteres">
                                    </sgt-form-control-error>
                                </div>
                            </div>
                        </ng-template>
                    </ng-template>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    <i class="fas fa-times"></i> Cancelar
                </button>

                <ng-template [ngIf]="req">
                    <!-- Aprovar -->
                    <button type="button" class="btn btn-success" id="btnRevisaoAprovar" (click)="aprovar()">
                        <i class="far fa-thumbs-up"></i> Aprovar
                    </button>
                </ng-template>
            </div>
        </div>
    </div>
</div>
